import { Card, CardContent, CardHeader } from "@pushpress/pushpress-ui";
import { AlertTriangle } from "lucide-react";

export default function ErrorFallback() {
  return (
    <div className="tw-min-h-screen tw-bg-blue-600 tw-flex tw-items-center tw-justify-center tw-p-4">
      <Card className="tw-w-full tw-max-w-md">
        <CardHeader>
          <div className="tw-flex tw-justify-center tw-space-x-2">
            <AlertTriangle className="tw-h-6 tw-w-6 tw-text-orange-500" />
          </div>
        </CardHeader>
        <CardContent>
          <p className="tw-flex tw-justify-center tw-space-x-2 tw-text-gray-600 tw-mb-4">
            The payment link you&apos;ve clicked on is either invalid or
            doesn&apos;t exist.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
